export default __webpack_public_path__ + "static/Pala_6-2632f10ed2c96ee489db94fd94248e97.png";